import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { RbacService } from '../../../auth/_services/rbac.service';

declare let mLayout: any;
@Component({
    standalone: false,
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {


    constructor(private rbacService: RbacService) {

    }

    canAccess(route: string): boolean {
        return this.rbacService.canAccessRoute(route);
    }
    ngOnInit() {

    }
    ngAfterViewInit() {

        mLayout.initAside();

    }

}
